<!-- ***Designed by Salman Rifai***** -->
<!-- ***CP-214*** -->

<!-- Hello Generic field -->
<div class="dhl-field-autocomplete-v2" [formGroup]="frmGroup">
    <div class="form-field-wrapper" [ngClass]="{'typing':typing}">
        <div class="form-field-control" #formControl
            [ngClass]="{'error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid)}">
            <input appFormFieldAutocompleteV2 #inputEle type="{{fieldType}}" class="base-field" autocomplete="off"
                [attr.data-placeholder]="placeholder | translate" [required]="configData.required"
                [formControlName]="$safeNavigationMigration(configData?.name)" [formControl]="frmGroup.get(configData.name)"
                [(ngModel)]="searchStr" (keyup)="onkeyupHandler($event)" (click)="setOnFocus($event)"
                (change)="controlValueChange($event)" />
            <span class="form-field-label">
                <label class="base-label">
                    {{$safeNavigationMigration(configData?.label) | translate}}
                    <span *ngIf="configData?.required"> *</span>
                </label>
            </span>
            <span *ngIf="fieldIcon" class="field-icon" (click)="popFieldAction($event)">
                <span class="default-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,662,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
                <span class="active-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,692,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
            </span>
        </div>
        <!-- <div class="cancel" *ngIf="typing"><img
                src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" (click)="close()" />
        </div> -->
        <div class="form-field-hint" *ngIf="frmGroup['secondaryText']">
            <!-- <span class="hint">Optional hint text</span> -->
            <span *ngIf="configData['secondaryText'] && frmGroup['secondaryText'].source !==',' && frmGroup['secondaryText'].destination !==',' ">
                <span>
                    {{frmGroup['secondaryText'].source}}
                </span>
                <span>
                    -
                </span>
                <span>
                    {{frmGroup['secondaryText'].destination}}
                </span>
            </span>
        </div>

        <div class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">{{ enum.Required_Validation | translate }}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.NoItemFound">{{enum.NoRecordFound_Validation | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.selectFromList">{{enum.SelectFromList_Validation | translate}}</span>
            </span>
        </div>
        <div *ngIf="progressBar" class="search-result spinner">
            <app-progress-spinner-v2 ></app-progress-spinner-v2>
        </div>
        <div *ngIf="typing && (suggestionList)?.length > 0" class="search-result">
            <div *ngIf="(suggestionList)?.length > 0" class="search-history-wrapper">
                <label class="search-history-label">Search History</label>
            </div>
            <div class="suggestion-list" [ngClass]="{'disabled':suggestion.disable}" *ngFor="let suggestion of suggestionList ">
                <img style="height: 20px; width: 20px;"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,630,24,24))" />
                <a class="list-items" (click)="selectItem($event,suggestion, suggestion.disable)">
                    <ng-container *ngIf="configData['primaryText'];">
                        <span class="suggestion-item"  style="display: inline-flex;flex-direction: column;">
                            <span [title]="suggestion.disable ? 'PO with different origin and destination is not allowed.': ''">
                                {{suggestion[configData['primaryText'][0]]}} -- {{suggestion[configData['primaryText'][1]]}}
                            </span>
                            <span *ngIf="configData['secondaryText'];">
                                <span class="secondary-label"
                                    *ngFor="let text of configData['secondaryText']; let rowIndex = index">
                                    {{suggestion[text]}}
                                    <span *ngIf="rowIndex === (configData['secondaryText'].length/2)-1; else addComma">
                                        ->
                                    </span>
                                    <ng-template #addComma>
                                        <span *ngIf="rowIndex !== configData['secondaryText'].length-1">, </span>
                                    </ng-template>
                                </span>
                            </span>
                        </span>
                        <!-- <span class="secondary-label"
                            [matTooltip]="suggestion.disable ? 'PO with different origin and destination is not allowed.': ''">
                            {{suggestion[configData.primaryText[0]]}} -- {{suggestion[configData.primaryText[1]]}}
                        </span> -->
                    </ng-container>
                </a>
            </div>
        </div>
    </div>
</div>